import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";

import TablaLoteInventario from './TablaLoteInventario';

const TablaLote = ({ lotes, productId, handleEditarLoteProducto, handleEditarLoteInventarioEspecífico, handleActualizarEstadoLoteInventario, parentDataTable }) => {
    const tableRef = useRef();

    function formatLoteInventario(loteInventarios, currentLoteId) {
        const container = document.createElement('div');
        container.className = "lote-inventario-details-container";

        const root = createRoot(container);
        root.render(
            <TablaLoteInventario
                loteInventarios={loteInventarios || []}
                productId={productId}
                loteId={currentLoteId}
                handleEditarLoteInventarioEspecífico={handleEditarLoteInventarioEspecífico}
                handleActualizarEstadoLoteInventario={handleActualizarEstadoLoteInventario}
            />
        );
        return container;
    }

    useEffect(() => {
        if (!lotes || lotes.length === 0) {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
                $(tableRef.current).empty();
            }
            return;
        }

        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
            $(tableRef.current).empty();
        }

        const table = $(tableRef.current).DataTable({
            data: lotes,
            columns: [
                {
                    targets: 0,
                    title: "Opciones",
                    data: null,
                    className: "dt-center",
                    searchable: false,
                    createdCell: (td, cellData, rowData) => {
                        const root = createRoot(td);
                        root.render(
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1em" }}>
                                <button
                                    key={`details-lote-${rowData.id}`}
                                    className="btn btn-info toggle-lote-inventario"
                                    title="Ver Inventarios del Lote"
                                    style={{ minWidth: "35px" }}
                                >
                                    <i className="fas fa-eye" />
                                </button>
                                <button
                                    key={`edit-lote-${rowData.id}`}
                                    className="btn btn-primary editar-lote-producto-btn"
                                    title="Editar Lote Producto"
                                    style={{ minWidth: "35px" }}
                                    onClick={() => handleEditarLoteProducto(productId, rowData.id)}
                                >
                                    <i className="fas fa-edit" />
                                </button>
                            </div>
                        );
                    },
                    orderable: false,
                },
                { targets: 1, title: "Id", data: "id" },
                { targets: 2, title: "Nombre Lote", data: "nombre_lote" },
                { targets: 3, title: "Cantidad", data: "cantidad" },
                { targets: 4, title: "Existencia", data: "existencia" },
                {
                    targets: 5,
                    title: "Estado Lote",
                    data: "estado",
                    render: (data) => {
                        return `<span class="badge ${data === "Disponible" ? "badge-success" : "badge-danger"}">${data}</span>`;
                    },
                },
            ],
            paging: true,
            lengthChange: false,
            searching: false,
            ordering: true,
            info: true,
            autoWidth: true,
            responsive: true,
            language: {
                decimal: "",
                emptyTable: "No hay información",
                info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
                infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
                infoFiltered: "(Filtrado de _MAX_ total entradas)",
                infoPostFix: "",
                thousands: ",",
                lengthMenu: "Mostrar _MENU_ Entradas",
                loadingRecords: "Cargando...",
                processing: "Procesando...",
                search: "Buscar:",
                zeroRecords: "Sin resultados encontrados",
                paginate: {
                    first: "|<<",
                    last: ">>|",
                    next: ">>",
                    previous: "<<",
                },
            },
            destroy: true,
        });

        $(tableRef.current).off('click', 'button.toggle-lote-inventario').on('click', 'button.toggle-lote-inventario', function () {
            const tr = $(this).closest('tr');
            const row = table.row(tr);

            if (row.child.isShown()) {
                row.child.hide();
                tr.removeClass('shown');
            } else {
                row.child(formatLoteInventario(row.data().loteinventarios, row.data().id)).show();
                tr.addClass('shown');
            }
            setTimeout(() => { table.columns.adjust().draw(); }, 0);
            if (parentDataTable) {
                setTimeout(() => { parentDataTable.columns.adjust().draw(); }, 0);
            }
        });

        return () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
            }
            $(tableRef.current).off('click', 'button.toggle-lote-inventario');
            $(tableRef.current).off('click', 'button.editar-lote-producto-btn');
        };
    }, [lotes, productId, handleEditarLoteProducto, handleEditarLoteInventarioEspecífico, handleActualizarEstadoLoteInventario, parentDataTable]);

    return (
        <div className="p-3 mb-2 bg-light border-left border-primary rounded">
            <h5>Detalles de Lotes</h5>
            <table
                ref={tableRef}
                className="table table-bordered table-hover nowrap tabla-lotes-detalles"
                style={{ width: "100%" }}
            ></table>
        </div>
    );
};

export default TablaLote;